import React, { useState, useEffect } from "react";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import { upload_document, upload_document_v2 } from "./CompanyAddressChanges";
import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import BusinessSearchNDetails from "../../../../../components/common/forms/BusinessSearchNDetails";
import api, { url } from "../../../../../api/api";
import { toast } from "react-toastify";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";


const OldCmpAddress = () => {
  const [cmpId, setCmpId] = useState(null);
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);

  const [uploadProof, setUploadProof] = useState('')

  const handleClick = (data) => {
    if (cmpId === null) {
      alert("First search company");
      return;
    }
    data.documents = docsOutput;
    data.company = cmpId;
    data.amendment_type = "address_change";
    console.log(data);

    const user = JSON.parse(localStorage.getItem("user"));

   
    api.post('services/company/amendments/', data)
    .then((response) => {
        toast.success("Data Registered Successfully")

        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"
       
        // };
     
        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });

        
      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong")
      });
  };

  let data = [];
  upload_document.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form className="px-2">
      {/* company name and other details */}
      <BusinessSearchNDetails setCmpId={setCmpId}/>
      {/* compnay name and other details close */}

      <div className="flex items-center p-3 border-2 border-t-0 border-primary-blue w-full">
        <span className="text-red-600 font-semibold font-Laila ">
        अब परिवर्तन गर्ने कम्पनीको नाम : 
        </span>
          <input className="outline-none text-primary-blue w-[50%] pl-3 " 
          {...register("new_company_address", { required: false })}
          
          />
       
      </div>

      <div className="border-2 bg-pink-100 border-primary-blue mt-3">
        <p className="text-primary-blue mt-0 md:text-lg text-base font-semibold font-Laila leading-10 text-center">
          शेयर सदस्यहरुको संख्याको आधारमा कम्पनीको ठेगाना परिवर्तन सम्बन्धि काम
          गर्दा तपाईको जम्मा लाग्ने रकम रु.१५,०००।– मात्र ।
        </p>
      </div>

      {/* upload documents open */}
      <div className="text-primary-blue font-Calistoga text-lg underline my-4">
        2. Upload Document
        <span className="text-primary-blue underline font-Laila">
          (शेयर लगत निकाल्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
          गर्नुहोस ।)
        </span>
      </div>

      {/* upload documents close */}
      <Documents
        documents_data={upload_document}
        initialState={data}
        setDocument={setDocsOutput}
      />
       <div className="text-primary-blue  font-Calistoga text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue underline font-Laila mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>

      <FormBranch register={register} name={"working_branch"} />
      <FormButtom />
      
      <NewFormPayment handleSubmit={handleSubmit} handleClick={handleClick} 
        setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default OldCmpAddress;
